module.exports = __webpack_public_path__ + "img/no-bank.c5c8a0fd.png";